import { ButtonStyle, ControlSize, FetchStatus, Property, PropertyType } from "../../../../../base/types";
import { IAsyncBoundProperties, usePropertyDraftText } from "../../../../../base/hooks";
import { useEffect, useState } from "react";

import { IActionButtonProps } from "./IActionButtonProps";
import { IPageLink } from "../../../../../base/models";

export const ActionButtonProperties = [
    { id: Property.MaterialIcon, name: 'Icon', type: PropertyType.MaterialIcon },
    { id: Property.Label, name: 'Label', type: PropertyType.String },
    { id: Property.PortalAction, name: 'Action', type: PropertyType.Action },
    { id: Property.ExecuteSave, name: 'Save and Execute', type: PropertyType.Boolean },
    { id: Property.AuthExecute, name: 'Auto execute on change data', type: PropertyType.Boolean },
    { id: Property.SystemId, name: 'System Id', type: PropertyType.String },
    { id: Property.PageLink, name: 'Navigate To', type: PropertyType.PageLink },
    { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    { id: Property.Disabled, name: 'Disabled', type: PropertyType.Boolean },
    { id: Property.BackgroundStyle, name: 'Style', type: PropertyType.ButtonStyle },
    { id: Property.Size, name: 'Size', type: PropertyType.ControlSize },
]

export const useActionButtonProperties = (props: IAsyncBoundProperties) => {
    const { status, result: bindings, error } = props;
    const [properties, setProperties] = useState<IActionButtonProps>()
    const draftText = usePropertyDraftText({ bindings, property: Property.Label })

    useEffect(() => {
        if (status !== FetchStatus.Success || !bindings)
            return;

        const label = bindings.getValue<string>(Property.Label)
        const title = bindings.getValue<string>(Property.Tooltip)
        const icon = bindings.getValue<string>(Property.MaterialIcon)
        const disabled = bindings.getValue<boolean>(Property.Disabled)

        const buttonStyle = bindings.getValue<ButtonStyle>(Property.BackgroundStyle)
        const buttonSize = bindings.getValue<ControlSize>(Property.Size)
        const submit = bindings.getValue<boolean>(Property.Submit)
        const type = submit ? "submit" : "button"

        const functionName = bindings.getValue<string>(Property.PortalAction)
        const systemId = bindings.getValue<string>(Property.SystemId)
        const pageLink = bindings.getValue<IPageLink>(Property.PageLink)
        const executeSave = bindings.getValue<boolean>(Property.ExecuteSave)
        const autoExecute = bindings.getValue<boolean>(Property.AuthExecute)

        setProperties({
            label, type, title, icon, disabled, buttonStyle, buttonSize,
            functionName, systemId, pageLink, executeSave, autoExecute
        })
        // eslint-disable-next-line
    }, [bindings, status]);

    return { status, error, bindings, properties, draftText }
}
